import type { AiBannerSlot } from '../../AiPlanRecommendationCard/AiPlanRecommendationBanner';

export type AiBannerPlacement = AiBannerSlot | 'none';

interface AiBannerPlacementInput {
  isBannerVariant: boolean;
  isAiRecommended: boolean;
  hasSale: boolean | undefined;
}

export const getAiBannerPlacement = ({
  isBannerVariant,
  isAiRecommended,
  hasSale,
}: AiBannerPlacementInput): AiBannerPlacement => {
  if (!isBannerVariant || !isAiRecommended || hasSale === undefined) {
    return 'none';
  }
  return hasSale ? 'top' : 'hat';
};
